// extracted by mini-css-extract-plugin
export default {"text_editor":"texteditor_text_editor__DPiYJ","lable":"texteditor_lable__A-rnL","wrapper":"texteditor_wrapper__0PMca","editor":"texteditor_editor__SH+gp"};